import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { FileView } from 'app/models/file-view.enum';

@Component({
  selector: 'app-switch-files',
  templateUrl: './switch-files.component.html',
  styleUrls: ['./switch-files.component.scss']
})
export class SwitchFilesComponent implements OnInit {

  @Input() fileView: FileView;
  @Output() changeView: EventEmitter<FileView> = new EventEmitter();
  ViewType = FileView;

  constructor() {
    this.fileView = FileView.Tile;
  }

  ngOnInit() {
    this.switchView(this.fileView);
  }

  switchView(fileView: FileView): void {
    this.fileView = fileView;
    this.changeView.emit(fileView);
  }

}
